
import React from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import "./../Custom.css";
import { objectToFormData, findLodash } from '../../../../utils';
import { addProjectsField, updateProjectsField } from '../../../../actions/companySettings';
import { Input, Form, Button, Select } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

const ValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please provide category name'),
  code: yup.string(),
  description: yup.string(),
});

const AddProjectsField = (props) => {
  const { id: currentId, employeesData = [] } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const projectsFieldResponse = useSelector(state => state.companySetting.getProjectsField || {});
  // const addProjectsFieldResponse = useSelector(state => state.companySetting.addProjectsField || {});

  React.useEffect(() => {
    form.resetFields();
    if (projectsFieldResponse.success && currentId) {
      const editValues = findLodash(projectsFieldResponse.data.response.projects, { id: currentId }) || {};
      form.setFieldsValue({
        name: editValues.name,
        code: editValues.code,
        description: editValues.description,
        user_id: editValues.user_id,
        is_enable: editValues.is_enable,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleSubmit = (values) => {
    const payload = {};
    [
      'code',
      'name',
      'description',
      'user_id',
      'is_enable',
    ].forEach(item => {
      payload[item] = values[item] || false;
    });

    payload.is_enable = true;

    ValidationSchema.validate(payload)
      .then(function ({ ...value }) {
        Object.keys(payload).forEach(key => {
          if (!payload[key] && key !== "is_enable") {
            delete payload[key];
          }
        });
        currentId ?
          dispatch(updateProjectsField(objectToFormData({ ...payload, id: currentId.toString() }))) :
          dispatch(addProjectsField(objectToFormData({ ...payload })));
        form.resetFields();
      })
      .catch(function (err) {
      });
  }

  const handleCancelButton = () => {
    form.resetFields();
    props.handleCancel();
  }

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className="modal-form custom-form small-width"
      >
        <Form.Item label="Projects Name" name="name" rules={[{ required: true, message: 'Please enter name' }]}>
          <Input placeholder="Enter Projects Name" maxLength={50} />
        </Form.Item>
        <Form.Item label="Projects Code" name="code">
          <Input placeholder="Enter Projects Code" />
        </Form.Item>
        <Form.Item name="user_id" label="Projects Head">
          <Select
            placeholder="Select Projects Head"
          >
            {employeesData && employeesData.map(({ user_id, name }) => <Option key={user_id} value={user_id}>{name}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>

        <Button key="1" htmlType="submit" className="formButton mt1">{currentId ? 'Update' : 'Save'}</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    </>
  );
}

export default AddProjectsField;

